export default __webpack_public_path__ + "static/media/8 - Ghost Flowers.2e6327ce.jpeg";